import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-101" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-102" data-mp="1cf03nb26x4mz">
        <div className="text-center mb-16" data-id="element-103" data-mp="1cgb8le7dgifo">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-neutral-900 uppercase" data-id="element-104" data-mp="2a1ytb1ugtcbd">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-105" data-mp="2512pspe0zs6h">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-neutral-100 border border-neutral-200 rounded-xl overflow-hidden" data-id="element-106" data-mp="202hoemn1f2gg" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-amber-500" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-107" data-mp="oonr1mw02jq2">
                <span className="font-bold text-lg text-neutral-900 pr-8" data-id="element-108" data-mp="1apkj572mwo0q">{faq.q}</span>
                <ChevronDown className={`text-amber-600 transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-109" data-mp="1arwx7959ue8i" />
              </button>
              <AnimatePresence initial={false} data-id="element-110" data-mp="16p0ku06bred0">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-111" data-mp="rzuels92knvm">
                    <div className="px-6 pb-5 text-neutral-800/80 border-t border-neutral-200 pt-4 space-y-2" data-id="element-112" data-mp="n22kcrkycpo9">
                      {faq.a.map(paragraph => <p key={paragraph} data-id="element-113" data-mp="2kuvk42o3mkhx">{paragraph}</p>)}
                      {faq.list && <ul className="list-disc pl-5 grid sm:grid-cols-2 gap-x-4 gap-y-1" data-id="element-114" data-mp="2fx3k0ldavs2n">
                          {faq.list.map(item => <li key={item} data-id="element-115" data-mp="38l98nj7h617r">{item}</li>)}
                        </ul>}
                      {faq.afterList && <p data-id="element-116" data-mp="33n7mgper5ls2">{faq.afterList}</p>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}